import { useMemo } from "react";
import { useSearchParams } from "react-router";
import { usePaths } from "../../paths.ts";
import { type OriginCrumb, type RootOrigin, getRootOrigin, useOriginCrumbs } from "../useOriginCrumbs.ts";

interface UseInsightsOriginCrumbsArgs {
    insightId: string | null;
}

interface UseInsightsOriginCrumbsResult {
    crumbs: OriginCrumb[];
    origin: RootOrigin;
    buttonOrigin: RootOrigin;
}

export function useInsightsOriginCrumbs({ insightId }: UseInsightsOriginCrumbsArgs): UseInsightsOriginCrumbsResult {
    const paths = usePaths();
    const [searchParams] = useSearchParams();
    const category = searchParams.get("category");

    const origin = useMemo(() => getRootOrigin(searchParams), [searchParams]);
    const query = category ? new URLSearchParams({ category }).toString() : "";
    const fallback: OriginCrumb = {
        name: "Insights",
        link: query ? `${paths.insights}?${query}` : paths.insights
    };
    const crumbs = useOriginCrumbs(origin, fallback);
    const buttonOrigin = deriveButtonOrigin(origin, insightId);

    return { crumbs, origin, buttonOrigin };
}

export function deriveButtonOrigin(origin: RootOrigin, fallbackInsightId: string | null): RootOrigin {
    if (origin.kind === "overview" || origin.kind === "tenantInfo") {
        return origin;
    }

    return { kind: "insights", insightId: fallbackInsightId };
}
